'use client';

import Link from 'next/link';

import { Footer, Heading } from 'components/atomic/atoms';
import { HeaderOrganism } from 'components/atomic/organism';
import config from 'config/index';
import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';

const homePageURL = getPageURL({
  pageName: ROUTE_CONFIG.HOME_PAGE.label
});

const termsAndConditionPageURL = getPageURL({
  pageName: ROUTE_CONFIG.TERMS_AND_CONDITION.label
});

const privacyPolicyPageURL = getPageURL({
  pageName: ROUTE_CONFIG.PRIVACY_POLICY.label
});

export default function Terms() {
  return (
    <>
      <HeaderOrganism heading='Terms and Conditions' />
      <main>
        <div className='policy-content'>
          <div className='bg-lets-go-btn max-h-35 md:max-h-64 h-full min-h-35 md:min-h-64'>
            <div className='text-center pt-7 md:pt-12'>
              <Heading
                level={2}
                className='text-lg md:text-4xl leading-6 md:leading-8 font-Montserrat font-medium'
              >
                Terms and Conditions
              </Heading>
            </div>
          </div>

          <div className='max-w-xs md:max-w-5xl w-full bg-white mx-auto rounded-xl transform -translate-y-16 md:-translate-y-32 shadow-profile'>
            <div className='p-5 md:p-10 text-xs md:text-sm font-normal text-nero leading-4 md:leading-7 pb-2.5'>
              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Please read these Website Terms of Use carefully before using
                the site.{' '}
              </Heading>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 pb-2.5'
              >
                {' '}
                Introduction{' '}
              </Heading>
              <p>
                {' '}
                Thank you for visiting
                <Link
                  href={privacyPolicyPageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>
                .
              </p>
              <p>
                {' '}
                In these website terms of use <strong> (Terms),</strong>{' '}
                references to <strong> we, us, our </strong> means{' '}
                <strong>EVINOPS LIMITED.</strong> References to{' '}
                <strong> you </strong> and <strong> your</strong> are to users
                of our website.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                By using our website you accept these Terms{' '}
              </Heading>
              <p>
                {' '}
                These Terms, together with the documents referred to in it, set
                out the terms and conditions on which you make use of
                www.hafla.com. Please read these Terms carefully before you
                start to use
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>
                . By using our website, you confirm that you accept these Terms
                and that you agree to comply with them. If you do not agree to
                these Terms you must not use our website.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Other Terms that may apply to you{' '}
              </Heading>
              <p>
                {' '}
                These Terms refer to the following additional terms, which also
                apply to your use of our website:{' '}
              </p>

              <ul className='list-alpha list-inside ps-4 md:ps-5 my-2.5 space-y-1'>
                <li>
                  {' '}
                  Our Privacy Policy
                  <Link
                    href={privacyPolicyPageURL}
                    className='text-blue font-medium'
                  >
                    {' '}
                    www.hafla.com/privacy-policy{' '}
                  </Link>
                  ;{' '}
                </li>

                <li>
                  {' '}
                  Our Acceptable Use Policy
                  <Link
                    href={getPageURL({
                      pageName: ROUTE_CONFIG.ACCEPTABLE_USE_POLICY.label
                    })}
                    className='text-blue font-medium'
                  >
                    {' '}
                    www.hafla.com/acceptable-use-policy
                  </Link>
                  , which sets out the permitted uses and prohibited uses of our
                  site. When using our site, you must comply with this
                  Acceptable Use Policy;{' '}
                </li>

                <li>
                  {' '}
                  Our Cookie Notice
                  <Link
                    href={termsAndConditionPageURL}
                    className='text-blue font-medium'
                  >
                    {' '}
                    www.hafla.com/terms-and-conditions
                  </Link>
                  , which sets out information about the cookies on our site;
                  and{' '}
                </li>

                <li>
                  {' '}
                  if you purchase goods from our site, our terms and conditions
                  of supply
                  <Link
                    href={termsAndConditionPageURL}
                    className='text-blue font-medium'
                  >
                    {' '}
                    www.hafla.com/terms-and-conditions
                  </Link>{' '}
                  will apply to the sales.{' '}
                </li>
              </ul>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Who we are and how to contact us{' '}
              </Heading>
              <p>
                {' '}
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                is a website operated by <strong> EVINOPS LIMITED.</strong> We
                are registered as a Tech Startup in Abu Dhabi Global Market with
                company number 000005703 and have our registered office at
                DD-14-124-053, 14 Floor, WeWork Hub71, Al Khatem Tower, ADGM
                Square, Al Maryah Island, Abu Dhabi, UAE, Abu Dhabi, 46617,
                United Arab Emirates.{' '}
              </p>

              <p>
                {' '}
                If you have any queries or concerns regarding
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                or the information contained on it, please contact us at{' '}
                <a
                  className='text-blue font-medium'
                  href={`mailto:${config.haflaEmail.contactUs}`}
                >
                  {config.haflaEmail.contactUs}
                </a>
                .
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Website Content{' '}
              </Heading>
              <p>
                {`The content on our website is provided on an "as is" basis and
                all information, commentary and other materials displayed on our
                website are intended for general information purposes only. It
                is not intended to amount to advice on which you should rely.
                You must obtain professional or specialist advice before taking,
                or refraining from, any action on the basis of the content on
                our website.`}
              </p>

              <p>
                {' '}
                We update our website regularly and may change the content at
                any time. Although we make reasonable efforts to update the
                information on our website, we make no representations,
                warranties or guarantees, whether express or implied, that the
                content on our site is accurate, complete or up-to-date.
                Therefore, we disclaim all liability and responsibility arising
                as a result of any reliance placed on such information,
                commentary or other materials contained on
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                by any visitor to our website or by anyone who may be informed
                of any of its content.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Restrictions on access and use{' '}
              </Heading>

              <span className='font-semibold text-nero py-2.5 block'>
                {' '}
                Website access{' '}
              </span>
              <p>
                {' '}
                Our site is made available free of charge. We do not guarantee
                that our site, or any content on it, will always be available or
                be uninterrupted. If our website is unavailable for any reason
                and at any time (including for any period of time), we shall not
                be liable to you for such an occurrence.{' '}
              </p>

              <p>
                {' '}
                To register on our website you must be 18 years or older. Only
                one registration is allowed per person and once registered, you
                must ensure you keep your registration information
                up-to-date.{' '}
              </p>

              <span className='font-semibold text-nero py-2.5 block'>
                {' '}
                Suspension, withdrawal and restriction of access{' '}
              </span>
              <p>
                {' '}
                We may in our absolute discretion, suspend, withdraw or restrict
                access to all or some parts of our website to any persons, which
                shall include, for the avoidance of doubt, users who have
                registered with us.{' '}
              </p>

              <span className='font-semibold text-nero py-2.5 block'>
                {' '}
                Termination of access{' '}
              </span>
              <p>
                {' '}
                We may at our absolute discretion, terminate your access to{' '}
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                at any time and without notice.{' '}
              </p>

              <span className='font-semibold text-nero py-2.5 block'>
                {' '}
                User ID and password{' '}
              </span>
              <p>
                If you establish an account on
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>
                {`you are responsible for maintaining the confidentiality of your
                user ID and password, and you are responsible for all activities
                that occur under that user ID or password. You agree that you
                will not allow anyone to use your account and that you will not
                use anyone else's account.`}
              </p>

              <p>
                {' '}
                We have the right to disable any user ID or password, whether
                chosen by you or allocated by us, at any time, if in our
                reasonable opinion you have failed to comply with any of the
                provisions of these Terms.{' '}
              </p>

              <p>
                {' '}
                If you know or suspect that your user ID or password has been
                unlawfully disclosed or there has been a known or possible
                breach of security, you must promptly notify us at{' '}
                <a
                  className='text-blue font-medium'
                  href={`mailto:${config.haflaEmail.contactUs}`}
                >
                  {config.haflaEmail.contactUs}
                </a>
                .
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                How you may use material on our site{' '}
              </Heading>
              <p>
                {' '}
                All intellectual property rights contained in the website and
                all materials published on the website are owned and/or licensed
                by us with all such rights reserved.{' '}
              </p>

              <p>
                {' '}
                Except as expressly provided in these Terms, no part of
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                may be copied, reproduced, uploaded, posted, publicly displayed,
                encoded, translated, transmitted or distributed in any way
                (including mirroring) to any other computer, server, website or
                other medium for publication or distribution or for any
                commercial enterprise, without the express written consent of
                Evinops Limited.{' '}
              </p>
              <p>
                {' '}
                You may download publicly-available content on
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                only for your personal, non-commercial use, provided that:{' '}
              </p>

              <ul className='list-alpha list-inside ps-4 md:ps-5 my-2.5 space-y-1'>
                <li>
                  {' '}
                  you keep intact all copyright and other proprietary notices;
                  and{' '}
                </li>
                <li>
                  {' '}
                  if your copying or use of copyrighted materials on
                  <Link
                    href={homePageURL}
                    className='text-blue font-medium'
                  >
                    www.hafla.com
                  </Link>
                  {`is other than "fair use" under applicable copyright laws, you
                  must seek permission directly from us.`}
                </li>
              </ul>

              <p>
                {' '}
                If you print off, copy or download any part of our website in
                breach of these Terms, your right to use our website will cease
                immediately and you must, at our option, return or destroy any
                copies of the materials you have made.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Linking to and from our site{' '}
              </Heading>
              <p>
                {' '}
                Where our site contains links to other sites and resources
                provided by third parties, these links are provided for your
                information only. Such links should not be interpreted as
                approval by us of those linked sites or information you may
                obtain from them. We have no control over the contents of those
                sites or resources. We exclude, to the fullest extent permitted
                by law, all liability that may arise in connection with or as a
                result of such external site material causing any damage, costs,
                injury or financial loss of any kind.{' '}
              </p>

              <p>
                {' '}
                You may link to our home page, provided you do so in a way that
                is fair and legal and does not damage or take advantage of, our
                reputation. You must not establish a link in a way that suggests
                any form of association, approval or endorsement on our part
                where none exists. You must not establish a link to our site on
                any site that is not owned by you.{' '}
              </p>

              <p>
                {' '}
                Our site must not be framed on any other site, nor may you
                create a link to any part of our site other than the home page.
                We reserve the right to withdraw linking permission without
                notice. The site in which you are linking must comply in all
                respects with the content standards set out in our Acceptable
                Use Policy
                <Link
                  href={termsAndConditionPageURL}
                  className='text-blue font-medium'
                >
                  {' '}
                  www.hafla.com/terms-and-conditions
                </Link>
                . If you wish to link to or make any use of the content on our
                site other than that set out above, please contact us at{' '}
                <a
                  className='text-blue font-medium'
                  href={`mailto:${config.haflaEmail.contactUs}`}
                >
                  {config.haflaEmail.contactUs}
                </a>
                .
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Uploading content to our website{' '}
              </Heading>
              <p>
                {' '}
                Whenever you make use of a feature that allows you to upload
                content to our website, or to make contact with other users of
                our website, you must comply with the content standards set out
                in our Acceptable Use Policy
                <Link
                  href={termsAndConditionPageURL}
                  className='text-blue font-medium'
                >
                  {' '}
                  www.hafla.com/terms-and-conditions
                </Link>
                .
              </p>

              <p>
                {' '}
                You warrant that any such contribution does comply with those
                content standards, and you will be liable to us and indemnify us
                for any breach of that warranty. This means you will be
                responsible for any loss or damage we suffer as a result of your
                breach of warranty.{' '}
              </p>

              <p>
                {' '}
                Any content you upload to our website will be considered
                non-confidential and non-proprietary. You retain all of your
                ownership rights in your content, but you are required to grant
                us and other users of our site a limited licence to use, store
                and copy that content and to distribute and make it available to
                third parties. We also have the right to disclose your identity
                to any third party who is claiming that any content posted or
                uploaded by you to our Website constitutes a violation of their
                intellectual property rights, or of their right to privacy.{' '}
              </p>

              <p>
                {' '}
                We have the right to remove any posting you make on our website
                if, in our opinion, your post does not comply with the content
                standards set out in our Acceptable Use Policy
                <Link
                  href={termsAndConditionPageURL}
                  className='text-blue font-medium'
                >
                  {' '}
                  www.hafla.com/terms-and-conditions
                </Link>
                .{' '}
              </p>
              <p>
                {' '}
                You are solely responsible for securing and backing up your
                content.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                User-generated content is not approved by us{' '}
              </Heading>
              <p>
                {' '}
                This site may include information and materials uploaded by
                other users of the site, including to bulletin boards and chat
                rooms. This information and these materials have not been
                verified or approved by us. The views expressed by other users
                on our site do not represent our views or values. If you wish to
                complain about information and materials uploaded by other users
                please contact us at{' '}
                <a
                  className='text-blue font-medium'
                  href={`mailto:${config.haflaEmail.contactUs}`}
                >
                  {config.haflaEmail.contactUs}
                </a>
                .
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                We are not responsible for viruses and you must not introduce
                them{' '}
              </Heading>

              <p>
                {' '}
                We do not guarantee that our site will be secure or free from
                bugs or viruses.{' '}
              </p>

              <p>
                {' '}
                You are responsible for configuring your information technology,
                computer programs and platform to access our site. You should
                use your own virus protection software.{' '}
              </p>

              <p>
                {' '}
                You must not misuse our site by knowingly introducing viruses,
                trojans, worms, logic bombs or other material that is malicious
                or technologically harmful. You must not attempt to gain
                unauthorized access to our site, the server on which our site is
                stored or any server, computer or database connected to our
                website. You must not attack our site via a denial-of-service
                attack or a distributed denial-of-service attack. We will report
                any such breach to the relevant law enforcement authorities and
                we will co-operate with those authorities by disclosing your
                identity to them. In the event of such a breach, your right to
                use our site will cease immediately.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Data Protection and Privacy{' '}
              </Heading>
              <p>
                {' '}
                We shall comply with all applicable data protection legislation,
                including the General Data Protection Regulation ((EU)
                2016/679), and any other national implementing laws, regulations
                and secondary legislation relating to data protection or
                privacy, as each of the foregoing may be amended, updated,
                consolidated, replaced and/or re-enacted from time to time.{' '}
              </p>

              <p>
                {' '}
                We shall use and process your personal information in accordance
                with our Cookie Notice
                <Link
                  href={termsAndConditionPageURL}
                  className='text-blue font-medium'
                >
                  {' '}
                  www.hafla.com/terms-and-conditions{' '}
                </Link>{' '}
                and Privacy Policy{' '}
                <Link
                  href={privacyPolicyPageURL}
                  className='text-blue font-medium'
                >
                  {' '}
                  www.hafla.com/privacy-policy
                </Link>
                .
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Our Liability{' '}
              </Heading>

              <p>
                {' '}
                Whilst we try to ensure that all information on
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                is accurate, no guarantees, representations or warranties are
                given that the content of our website is accurate, complete,
                up-to-date or error-free. Use of
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                is entirely at your own risk.
              </p>

              <p>
                {' '}
                To the fullest extent permitted by law, we hereby expressly
                exclude:{' '}
              </p>

              <ul className='list-alpha list-inside ps-4 md:ps-5'>
                <li>
                  {' '}
                  all conditions, warranties and other terms which might
                  otherwise be implied by statute, common law or the law of
                  equity; and{' '}
                </li>

                <li>
                  {' '}
                  any liability for any direct, indirect or consequential loss
                  or damage incurred by any user in connection with our website
                  or in connection with the access, use, inability to use, or
                  results of the use of our website, any websites linked to it
                  and any materials posted on it, including liability for:{' '}
                </li>

                <ul className='list-roman list-inside ps-4 md:ps-5 my-2.5 space-y-1'>
                  <li> Loss of business; </li>
                  <li> Loss of income or revenue; </li>
                  <li> Loss of profits or contracts; </li>
                  <li> Loss of anticipated savings; </li>
                  <li> Loss of data; </li>
                  <li> Loss of goodwill; </li>
                  <li> Wasted management or office time; </li>
                  <li>
                    {' '}
                    Loss or damage caused to any equipment or software; or{' '}
                  </li>
                  <li>
                    {' '}
                    Any other loss or damage of any kind, however arising and
                    whether caused by tort (including negligence), breach of
                    contract or otherwise, even if foreseeable.
                  </li>
                </ul>
              </ul>

              <p>
                {' '}
                We will not be liable for any loss or damage caused by a
                distributed denial-of-service attack, viruses, malicious code or
                other technologically harmful material that may infect your
                computer equipment, computer programs, data or other proprietary
                material due to your use of
                <Link
                  href={homePageURL}
                  className='text-blue font-medium'
                >
                  www.hafla.com
                </Link>{' '}
                or to your downloading of any material posted on it, or on any
                website linked to it.{' '}
              </p>

              <p>
                {' '}
                This does not affect our liability for death or personal injury
                arising from our negligence, nor our liability for fraud or
                fraudulent misrepresentation, or any other liability which
                cannot be excluded or limited under applicable law.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Severability{' '}
              </Heading>

              <p>
                {' '}
                In the event any provision or part-provision of these Terms is
                found by any court or other authority of competent jurisdiction
                to be invalid, unlawful or unenforceable, that provision or
                part-provision shall, to the extent required, be deemed not to
                form part of these Terms and the validity and enforceability of
                the other provisions of these Terms shall not be affected.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Variation{' '}
              </Heading>

              <p>
                Evinops Limited may at its sole discretion amend these Terms at
                any time. Every time you wish to use our website, please check
                these Terms to ensure you understand the terms that apply at
                that time.{' '}
              </p>

              <Heading
                level={3}
                className='font-Montserrat text-base md:text-xl leading-6 font-medium text-nero mt-4 md:mt-8 pb-2.5'
              >
                {' '}
                Governing Law and Jurisdiction{' '}
              </Heading>

              <p>
                {' '}
                These Terms shall be governed by, and construed in accordance
                with, the laws of England and Wales. Any dispute arising out of
                or in connection with these Terms, including any question
                regarding their existence, validity or termination, or arising
                from or related to use of our website, shall be subject to the
                exclusive jurisdiction of the Courts of Abu Dhabi Global
                Market.{' '}
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
